/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/components/HasParentPlaylist.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { usePlaylistIdFromSearch } from '../hooks.migrated';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/playlistContent/components/HasParentPlaylist.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const HasParentPlaylist = ({
  children,
  fallback = /*#__PURE__*/_jsx(_Fragment, {})
}) => {
  const playlistId = usePlaylistIdFromSearch();
  if (!playlistId) return /*#__PURE__*/_jsx(_Fragment, {
    children: fallback
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};